import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import ItemForm from './ItemForm';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AddItemPage = () => {
  return (
    <Container maxWidth={false} sx={{ py: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary">Back</Button>
        </Box>
        <Typography variant="h4" gutterBottom color="primary">
          Add New Item
        </Typography>
        <ItemForm />
      </Paper>
    </Container>
  );
};

export default AddItemPage; 